var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaitTimeHeaderOuterBlob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 348,
    viewBox: "0 0 330 348",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M324.185 195.3C304.288 294.455 240.408 364.823 143.427 344.48C46.4457 324.137 -16.0479 227.232 3.84879 128.076C23.7455 28.9209 114.607 -15.525 211.588 4.84859C308.599 25.1913 344.082 96.1444 324.185 195.3Z",
    fill: "#B9F5E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitTimeHeaderOuterBlob);
export default __webpack_public_path__ + "static/media/wait-time-header-outer-blob.fc1e7d5f6c65bfdd4455a795e548226f.svg";
export { ForwardRef as ReactComponent };